import { randomNames } from '@/helpers'

import uuid from 'uuid'

export const user = ({ user }) => user

export const userId = ({ user }) => (user ? user.id : undefined)

export const onlineAgents = ({ onlineAgents }) => onlineAgents

export const getNewGuestUser = () => () => {
  const randomName = randomNames()

  return {
    name: randomName,
    email: `guest-${uuid.v4().replace(/-/g, '')}@octachat.com`,
    guest: true
  }
}
